<template>
  <el-select
    style="width: 100%"
    clearable
    filterable
    collapse-tags
    @change="handleChange"
    @clear="handleClear"
    v-bind="$attrs"
    v-on="$listeners"
    v-loadmore:loadMore
  >
    <el-option v-for="opt in options" :key="opt.key ?? opt.value" :label="opt | getLabel" :value="opt.value" />
  </el-select>
</template>

<script>
  import { getValueByPath } from 'element-ui/lib/utils/util'
  export default {
    name: 'FormItemSelect',
    props: {
      item: Object,
      filter: Function,
    },
    data() {
      return {
        loadOptions: [],
        page: this.item?.loadParams?.page || 1,
        size: this.item?.loadParams?.size || 20,
      }
    },
    filters: {
      getLabel(item) {
        if (item.code) {
          return item.code + '-' + (item.label || item.label2)
        }
        return item.label || item.label2
      },
    },
    computed: {
      options() {
        return this.mapOptions(this.item.options || this.loadOptions)
      },
      loadMethod() {
        return this.item.loadMethod
      },
      loadParams() {
        return this.item.loadParams
      },
      resultProp() {
        return this.item.resultProp || 'data'
      },
      map() {
        return this.item.map
      },
      infiniteScrollEnabled() {
        return this.item.infiniteScrollEnabled || false
      },
    },
    mounted() {
      if (typeof this.loadMethod === 'function') {
        this.loadData().then((data) => {
          this.loadOptions = data
        })
      }
    },
    methods: {
      loadData() {
        let params = { ...this.loadParams }
        if (this.infiniteScrollEnabled) {
          params = {
            ...params,
            page: this.page++,
            size: this.size,
          }
        }
        return this.loadMethod(params).then((res) => {
          return getValueByPath(res, this.resultProp)
        })
      },
      loadMore() {
        if (this.infiniteScrollEnabled) {
          this.loadData().then((data) => {
            if (data?.length) {
              this.loadOptions.push(...data)
            }
          })
        }
      },
      mapOptions(data = []) {
        if (!this.map) return data
        let map = this.map
        if (typeof map !== 'function') {
          map = (item) => {
            const res = {}
            for (const key in this.map) {
              res[key] = item[this.map[key]]
            }
            return res
          }
        }
        if (typeof this.item.filter === 'function') {
          return data.map(map).filter(this.item.filter)
        }
        return data.map(map)
      },
      handleChange(value) {
        if (Array.isArray(value)) {
          const items = this.options.filter((item) => value.includes(item.value))
          this.$emit('itemChange', items)
          return
        }
        const item = this.options.find((item) => item.value === value)
        this.$emit('itemChange', item)
      },
      getDisplayValue() {
        if (this.$attrs.multiple) {
          return this.$children[0].selected.map((item) => item.currentLabel).join('、')
        }
        return this.$children[0].selected.currentLabel
      },
      handleClear() {
        this.$emit('input', null)
      },
      resetPage(page = 1) {
        this.page = page
      },
    },
  }
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px !important;
  font-style: normal;
}
::v-deep .el-input__inner::placeholder,
::v-deep .el-input__inner::-webkit-input-placeholder,
::v-deep .el-input__inner::-moz-placeholder,
::v-deep .el-input__inner:-ms-input-placeholder {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px !important;
  line-height: 40px;
  color: #333333 !important;
  font-style: normal;
  opacity: 1 !important;
}
</style>
